import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { KeyRound, Loader2 } from 'lucide-react';
import { passwordSchema } from '@ci-ville/shared';
import { Button, Input, Label } from '@ci-ville/ui';
import { api, ApiError } from '@/lib/api-client';
import { AuthShell, PasswordRules } from '@/components/AuthShell';
export function ResetPasswordPage() {
    const [params] = useSearchParams();
    const token = params.get('token') ?? '';
    const navigate = useNavigate();
    const [next, setNext] = useState('');
    const [confirm, setConfirm] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const valid = passwordSchema.safeParse(next).success && next === confirm;
    const submit = async (e) => {
        e.preventDefault();
        if (!valid)
            return;
        setSubmitting(true);
        try {
            await api.auth.resetPassword(token, next);
            toast.success('Mot de passe modifié. Vous pouvez vous connecter.');
            navigate('/login', { replace: true });
        }
        catch (err) {
            toast.error(err instanceof ApiError ? err.message : 'Lien invalide ou expiré');
        }
        finally {
            setSubmitting(false);
        }
    };
    if (!token) {
        return (_jsx(AuthShell, { title: "Lien incomplet", subtitle: "Ce lien de r\u00E9initialisation est invalide.", children: _jsx(Link, { to: "/forgot-password", className: "text-sm font-medium text-brand hover:underline", children: "Demander un nouveau lien" }) }));
    }
    return (_jsx(AuthShell, { title: "Nouveau mot de passe", children: _jsxs("form", { onSubmit: submit, className: "space-y-4", children: [_jsxs("div", { className: "space-y-2", children: [_jsx(Label, { htmlFor: "next", children: "Nouveau mot de passe" }), _jsx(Input, { id: "next", type: "password", autoComplete: "new-password", autoFocus: true, value: next, onChange: (e) => setNext(e.target.value) }), _jsx(PasswordRules, { value: next })] }), _jsxs("div", { className: "space-y-2", children: [_jsx(Label, { htmlFor: "confirm", children: "Confirmer" }), _jsx(Input, { id: "confirm", type: "password", autoComplete: "new-password", value: confirm, onChange: (e) => setConfirm(e.target.value) }), confirm && confirm !== next && _jsx("p", { className: "text-xs text-destructive", children: "Les deux mots de passe ne correspondent pas" })] }), _jsxs(Button, { type: "submit", size: "lg", variant: "brand", className: "w-full", disabled: !valid || submitting, children: [submitting ? _jsx(Loader2, { className: "animate-spin" }) : _jsx(KeyRound, {}), "Enregistrer"] })] }) }));
}
//# sourceMappingURL=ResetPasswordPage.js.map